import { useEffect } from 'react';

const useUpdateWrapperMinWidthStyle = (open: boolean) => {
  useEffect(() => {
    if (open) {
      const componentWrapper = document.querySelector('.component-wrapper');
      if (componentWrapper instanceof HTMLElement) {
        const mediaQuery = window.matchMedia('(min-width: 721px)');
        if (mediaQuery.matches) {
          componentWrapper.style.minWidth = 'inherit';
        }
      }
    }
  }, [open]);
};

export default useUpdateWrapperMinWidthStyle;
